import { css } from '@emotion/react';

export const adaptiveCardCss = css`
	[aria-invalid='true'] {
		outline: 1px solid rgb(196, 49, 75);
	}

	.ac-input.ac-textInput.ac-multiline {
		height: 200px;
	}

	.ac-input.ac-textInput,
	.ac-input.ac-numberInput,
	.ac-input.ac-dateInput,
	.ac-input.ac-timeInput,
	.ac-input.ac-multichoiceInput {
		border: 1px solid rgba(0, 0, 0, 0.23);
		border-radius: 4px;
		padding: 4px 8px 4px 8px;
	}

	.ac-container span.ac-textRun,
	label.ac-textBlock,
	div.ac-textBlock,
	.ac-input {
		font-family: 'Source Sans Pro' !important;
		font-size: 16px !important;
		font-weight: 400 !important;
		line-height: 24px !important;
		letter-spacing: 0.5px !important;
		color: black;
	}

	.ac-character-counter {
		color: rgba(0, 0, 0, 0.87) !important; /* theme.palette.text.primary */
	}
`;
